import { axios } from './ServiceUtils';

const getLabels = async (language) =>
  await axios.get(`api/resources?culture=${language}`).then((response) => response.data);

const getLabelsValues = async (language, keys) =>
  {
    var mountedKeys = keys.map(p => `key=${p}`).join('&');
    return await axios.get(`api/resources/values?culture=${language}&${mountedKeys}`).then((response) => response.data);
  };


  const getRequestAccessLabels = async (language) =>
  {
    const keys = [
      "public-pages-request-access-link",
      "public-pages-request-access",
      "public-pages-invalid-email",
      "gcp_link",
      "account_announcement_title",
      "account_announcement",
      "account_announcement_confirmation",
      "signin-button-continue",
      "signin-email-address",
      "new_account_name",
      "fail_login_modal_title",
      "fail_login_modal_content",
      "fail_login_modal_close",
      "signin-forgot-email-address-label",
      "signin-forgot-password-label",
      "signin-forgot-email-address-tooltip",
      "reset-password-message"
    ]
    let labels = await axios.get(`api/labels?q=${keys.join(",")}`,{
      headers: {
        'Content-Language': `${language}`,
      },
    }).then((response) => response.data)
    return {labels: labels.values};
  };
export { getLabelsValues, getLabels, getRequestAccessLabels };
